import { tokenService } from '@/api'
import { useQuery } from '@tanstack/react-query'

import { useMemo } from 'react'

export const useTokens = () => {
  const tokens = useQuery({
    queryKey: ['tokens'],
    queryFn: () => tokenService.GetAll(),
  })
  return useMemo(() => {
    if (tokens.isLoading) return { isLoading: true, data: {} }
    const tokenMap = (tokens as any).data
      .filter((_: any) => _.name === 'USDC')
      .reduce((obj: any, prop: any) => {
        obj[prop.chainId] = prop
        return obj
      }, {})
    return {
      data: tokenMap,
    }
  }, [tokens.data])
}
